import { Button, SpeedDial, SpeedDialAction, SpeedDialIcon } from '@mui/material';
import { useState } from 'react';
import { DynamicIcon } from 'src/components';

export type CreateButtonProps = {
  icon?: string;
  entityName?: string;
  onCreateClick?: () => void;
};

export const CreateButton = ({ entityName, onCreateClick, icon }: CreateButtonProps) => {
  const [openSpeedDial, setOpenSpeedDial] = useState(false);
  const handleOpenSpeedDial = () => setOpenSpeedDial(true);
  const handleCloseSpeedDial = () => setOpenSpeedDial(false);

  const speedDialActions = [
    {
      icon: icon ? <DynamicIcon name={icon} /> : undefined,
      name: `Create ${entityName}`,
      onClick: onCreateClick,
    },
  ];

  return (
    <>
      <SpeedDial
        ariaLabel={`${entityName} SpeedDial`}
        direction="down"
        sx={{
          display: { xs: 'block', md: 'none' },
          position: 'relative',
          top: '2.2rem',

          '.MuiSpeedDial-fab': {
            backgroundColor: (theme) => theme.palette.custom.OV.sys.primary,
            padding: 2,
            width: '1rem',
            height: '1rem',
            minHeight: 'auto',
          },
        }}
        icon={<SpeedDialIcon />}
        onClose={handleCloseSpeedDial}
        onOpen={handleOpenSpeedDial}
        open={openSpeedDial}
      >
        {speedDialActions.map((action) => (
          <SpeedDialAction
            key={action.name}
            icon={action.icon}
            tooltipTitle={action.name}
            tooltipOpen
            onClick={() => {
              handleCloseSpeedDial();
              action.onClick?.();
            }}
            sx={{
              '.MuiSpeedDialAction-staticTooltipLabel': {
                flexShrink: 0,
                fontSize: '0.875rem',
                whiteSpace: 'nowrap',
              },
            }}
          />
        ))}
      </SpeedDial>
      <Button
        data-testid="custom-view-create-button"
        color="primary"
        onClick={onCreateClick}
        sx={{
          display: { xs: 'none', md: 'block' },
          color: (theme) => theme.palette.custom.OV.sys.primary,
        }}
      >
        + Create {entityName}
      </Button>
    </>
  );
};
